import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import LoadingView from './components/LoadingView';
import ScrollToTop from './components/ScrollToTop';
import ComplementCadastroGate from './components/ComplementCadastroGate';
import './App.css';

const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const Plans = lazy(() => import('./pages/Plans'));
const Blog = lazy(() => import('./pages/Blog'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const Appointment = lazy(() => import('./pages/Appointment'));
const MyAppointments = lazy(() => import('./pages/MyAppointments'));
const MyPets = lazy(() => import('./pages/MyPets'));
const PontosHistorico = lazy(() => import('./pages/PontosHistorico'));
const EditAppointment = lazy(() => import('./pages/EditAppointment'));
const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess'));
const PaymentFailed = lazy(() => import('./pages/PaymentFailed'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Suspense fallback={<LoadingView message="Carregando..." fullPage />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servicos" element={<Services />} />
              <Route path="/planos" element={<Plans />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/agendamento" element={<Appointment />} />
              <Route path="/meus-agendamentos" element={<MyAppointments />} />
              <Route path="/meus-pets" element={<MyPets />} />
              <Route path="/pontos-historico/:petId" element={<PontosHistorico />} />
              <Route path="/editar-agendamento/:appointmentId" element={<EditAppointment />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/failed" element={<PaymentFailed />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <WhatsAppButton />
        <ComplementCadastroGate />
      </div>
    </Router>
  );
}

export default App;
